import { ChatMessageRole } from "src/base-components/Chat/types";

type ChatMessageProps = {
  role: ChatMessageRole;
  roleLabel?: string;
  children: React.ReactNode;
  renderActions?: () => React.ReactNode;
  dataLoc?: string;
};

const DEFAULT_LABELS: Record<ChatMessageRole, string> = {
  assistant: "Copilot",
  user: "User",
};

export const ChatMessage: React.FC<ChatMessageProps> = ({
  role,
  roleLabel,
  children,
  renderActions,
  dataLoc,
}) => (
  <li className="group flex flex-col gap-y-2" data-loc={dataLoc}>
    <div className="flex items-center justify-between gap-x-4">
      <span className="font-inter-normal-12px text-gray-500">
        {roleLabel ?? DEFAULT_LABELS[role]}
      </span>
      {renderActions?.()}
    </div>
    <div>{children}</div>
  </li>
);
